// Auto-generated file. Do not modify.
export const APP_VERSION = '2.0.0.31';
export const BUILD_NUMBER = 31;
export const VERSION = '2.0.0';
export const FULL_VERSION = '2.0.0.31';
export const GIT_HASH = 'b32a445';
export const GIT_BRANCH = 'release-v1.0.0';
export const BUILD_INFO = '2.0.0.31 (b32a445)';
export const RELEASE_NAME = '';
